import {
  EVENT_LISTENER_METHODS,
  eventBus,
  hideParticipantList,
  useBaseStore,
  useHideChatButton,
} from '@cometchat/calls-sdk-core';
import React, { useCallback } from 'react';
import Icon from '../icon/Icon.web';

const ChatButton: React.FC = () => {
  const hideChatButton = useHideChatButton();
  const chatButtonUnreadCount = useBaseStore(
    state => state.chatButtonUnreadCount,
  );

  const onPress = useCallback(() => {
    hideParticipantList();
    eventBus.publish({
      type: EVENT_LISTENER_METHODS.ButtonClickListener.onChatButtonClicked,
    });
  }, []);

  if (hideChatButton) {
    return null;
  }
  return (
    <button
      className="cometchat-calls-header-action-button"
      onClick={onPress}
      aria-label="Chat"
      title="Chat"
      data-testid="cometchat-calls-chat-button">
      <Icon name="chat" fill="var(--cometchat-calls-static-white)" />
      {chatButtonUnreadCount > 0 ? (
        <div
          className="cometchat-calls-header-badge"
          data-test-id="cometchat-calls-header-badge">
          {chatButtonUnreadCount > 99 ? '99+' : chatButtonUnreadCount}
        </div>
      ) : null}
    </button>
  );
};

export default ChatButton;
